import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {getAccountType} from './AccountSummaryConfig';

function AccountDesignation({accountTypeId, children, onClick}) {
	return (
		<StyledAccountDesignationDropdown className="StyledAccountDesignationDropdown" onClick={onClick}>
			<span className="designation-label">{getAccountType(accountTypeId)}</span>
			{children}
		</StyledAccountDesignationDropdown>
	);
}

AccountDesignation.propTypes = {
	accountTypeId: PropTypes.number.isRequired,
	children: PropTypes.node,
	onClick: PropTypes.func.isRequired
};

const StyledAccountDesignationDropdown = styled.section`
	align-items: center;
	display: flex;
	padding: 0;
	text-align: left;
	font-weight: 600;
	font-size: var(--px-12);
	line-height: var(--px-16);
	.designation-label {
		color: var(--neutrals-900);
		display: inline-block;
		font-size: var(--px-12);
		margin-left: var(--px-3);
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: middle;
		white-space: nowrap;
		width: calc(100% - var(--px-20));
	}
	.designation-icon {
		svg {
			fill: var(--neutrals-900) !important;
			width: var(--px-16) !important;
			height: var(--px-16) !important;
		}
	}
	.designation-icon {
		svg {
			fill: var(--neutrals-900) !important;
			width: var(--px-16) !important;
			height: var(--px-16) !important;
		}
	}
`;

export default AccountDesignation;
